<template>
  <main class="form-signin w-100 m-auto">
      <form @submit.prevent="handleForm">
        <img class="rounded-full" src="./assets/logo.png" alt="Traction Logo" />
        <!-- <img class="mb-4" src="/docs/5.3/assets/brand/bootstrap-logo.svg" alt="" width="72" height="57"> -->
        <h1 class="h3 mb-3 fw-normal">Receipt Generator</h1>

        <div class="form-floating mb-2">
          <input type="text" class="form-control" v-model="tid" placeholder="name@example.com">
          <label for="floatingInput">Terminal ID</label>
        </div>
        <div class="mt-2">
          <label for="floatingPassword">STAN or RRN</label>
          <select v-model="mode" class="form-control">
            <option value="">Select </option>
            <option value="stan">STAN</option>
            <option value="rrn">RRN</option>
          </select>
        </div>
        <div class="form-floating mt-2" v-if="mode=='stan'">
          <input type="text" class="form-control" v-model="stan">
          <label for="floatingPassword">STAN</label>
        </div>
        <div class="form-floating mt-2" v-if="mode=='rrn'">
          <input type="text" class="form-control" v-model="rrn" >
          <label for="floatingPassword">RRN</label>
        </div>
          <button v-if="!searchActive" class="btn btn-primary w-100 py-2 mt-3 btn-lg" type="submit">  
            <span class="" :class="isLoading ? 'spinner-border spinner-border-sm': ''" aria-hidden="true">
            </span>
          Generate
        </button>
        <div class="row mt-2" v-else>
          <div class="col-12">
            <button class="w-100 btn btn-danger py-2 my-2 col btn-sm" @click="searchActive=false">Reset</button>
          </div>
          <div class="col-6">
            <button class="btn w-100 btn-secondary py-2 btn-sm" @click="generateReceipt">Download PDF</button>
          </div>
          <div class="col-6">
            <button class="w-100 btn btn-dark py-2 col btn-sm" @click="generateReceiptJPG">Download JPG</button>
          </div>
          
        </div>
      </form>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="Terminal Receipt"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a5"
        pdf-orientation="portrait"
        pdf-content-width="350px"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
        :html-to-pdf-options="htmlToPdfOptions"
    >
      <section slot="pdf-content">
        <div
          style="max-width:360px;padding: 10px 20px"
          class="receipt"
          ref="printcontent"
        >
          <img class="bank-logo" :src="receiptDetails.bankLogo" />

          <h5 class="text-center text-600 mb-3">
            {{ receiptDetails.businessName }}
          </h5>
          <p class="text-xs uppercase">Merchant Name:</p>
          <p>TRACTION APPS LTD LA LANG</p>
          <p class="text-xl">
            TERMINAL ID : {{ receiptDetails.transactingTerminalId }}
          </p>
          <p class="text-center text-xl text-600 py-2">PURCHASE</p>
          <p class="text-sm">STAN: {{ receiptDetails.stan }}</p>
          <p class="text-sm">
            DATE/TIME :
            {{ moment(`${receiptDetails.transactionDate} ${receiptDetails.transactionTime}`, "YYYY-MM-DD HHmmss").format("DD MMM YYYY - h:mm:ss a") }}
          </p>
          <h5 class="text-md text-600 py-2">
            AMOUNT: NGN{{ computedAmount }}
          </h5>
          <p class="text-sm">{{ receiptDetails.cardlabel }}</p>
          <h5 class="text-md text-center py-2">{{ receiptDetails.maskedPan }}</h5>
          <p class="text-sm">
            EXPIRY DATE:
            <span class="font-bold">{{ receiptDetails.cardExpiryDate }}</span>
          </p>
          <p class="text-center text-md text-600 py-2">
            {{
              receiptDetails.responseCode == "00"
                ? "Transaction APPROVED"
                : "Transaction FAILED"
            }}
          </p>
          <p class="text-sm">
            Response Code: {{ receiptDetails.status }}
          </p>
          <p class="text-sm">Transaction ID: {{ receiptDetails.transactionId }}</p>
          <p class="text-sm">RRN: {{ receiptDetails.rrn }}</p>
          <p class="text-xs text-center pt-5">Powered by Traction</p>
          <p class="text-xs text-center pb-5">www.tractionapps.co</p>
        </div>
      </section>
    </vue-html2pdf>
    </main>

</template>

<script>
import moment from "moment";
import html2canvas from "html2canvas";
import VueHtml2pdf from "vue-html2pdf";
export default {
components: {
VueHtml2pdf,
},
data() {
return {
  moment,
  isLoading: false,
  tid: "",
  stan: "",
  rrn: "",
  searchActive: false,
  receiptDetails: {},
  mode: ''
};
},
computed: {
  htmlToPdfOptions() {
    return {
      margin: 0,
      filename: `Transaction Receipt`,

      image: {
        type: "jpg",
        quality: 0.98,
      },

      enableLinks: false,

      html2canvas: {
        scale: 1,
        dpi: 199,
        letterRendering: true,
        useCORS: true,
        allowTaint: true,
      },

      jsPDF: {
        unit: "pt",
        format: "a5",
        orientation: "portrait",
      },
    };
  },
  computedAmount(){
    return this.receiptDetails.amount;
  }
},
filters: {
truncate: function (text, length, suffix) {
  if (text.length > length) {
    return text.substring(0, length) + suffix;
  } else {
    return text;
  }
},
},
async mounted() {},
created() {
  // console.log(this.number_format(123445678, 2, '.', ','));
},
methods: {
  async handleForm(){
    this.isLoading = true;
    
    const baseUrl = process.env.VUE_APP_API_BASE_URL;
    const url = `${baseUrl}/getbyterminalIdandref`;

    // Choose reference based on mode
    const reference = this.mode === 'stan' ? this.stan : this.rrn;

    const payload = {
      terminalId: this.tid,
      reference: reference
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*'
      },
      body: JSON.stringify(payload)
    };

    fetch(url, requestOptions)
      .then(response => response.text())
      .then(result => {
        // console.log(result);
        const res = JSON.parse(result);
        this.isLoading = false;
        
        if (!res.success) {
          // Handle error case - transaction not found or other errors
          alert(res.message || 'Transaction not found');
        } else {
          // Handle success case
          this.searchActive = true;
          // console.log(result)
          this.receiptDetails = res.data;
        }
      })
      .catch((error) => {
        alert(error)
        console.log('error', error)
      });
  },
  async generateReceipt() {
    this.$refs.html2Pdf.generatePdf();
  },
  async generateReceiptJPG() {
    const el = this.$refs.printcontent;

    const options = {
      type: "dataURL",
      useCORS: true,
      allowTaint: true,
    };
    const printCanvas = await html2canvas(el, options);

    const link = document.createElement("a");
    link.setAttribute("download", "download.png");
    link.setAttribute(
      "href",
      printCanvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream")
    );
    link.click();

    console.log("done");
  },
  number_format (number, decimals, dec_point, thousands_sep){
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
},
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap");
.receipt p {
  font-family: "Courier Prime", monospace;
}

.receipt h5 {
  font-family: "Courier Prime", monospace;
}

html,
body {
height: 100%;
}

.form-signin {
max-width: 400px;
padding: 1rem;
}

.form-signin .form-floating:focus-within {
z-index: 2;
}

.form-signin input[type="email"] {
margin-bottom: -1px;
border-bottom-right-radius: 0;
border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
margin-bottom: 10px;
border-top-left-radius: 0;
border-top-right-radius: 0;
}
</style>
